import { createContext, useContext } from "react";
import type { ISubscriptionProviderContextValue } from "./SubscriptionProvider.types";

export const SubscriptionProviderContext = createContext<ISubscriptionProviderContextValue>({} as ISubscriptionProviderContextValue);

export function useSubscriptionProviderContext() {
  return useContext<ISubscriptionProviderContextValue>(SubscriptionProviderContext);
}
